export default __webpack_public_path__ + "static/media/2118.ef84f603.png";